<mat-card class="confirm-card">
  <mat-card-title>
    {{ '+SETTINGS.NOTIFICATION_SETTINGS' | translate }}
  </mat-card-title>
  <mat-icon (click)="onClose()" class="close-icon">close</mat-icon>
  <mat-card-content data-at-dialog-body>
    <app-configure-central-email></app-configure-central-email>
    <app-configure-notification-recipients></app-configure-notification-recipients>
  </mat-card-content>
</mat-card>
